class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.announcement-bar-slider');
    this.slides = this.querySelectorAll('.announcement-bar__slide');
    this.prevBtn = this.querySelector('.slider-button--prev');
    this.nextBtn = this.querySelector('.slider-button--next');
    this.currentIndex = 0;
    this.total = this.slides.length;

    // Auto rotate config
    this.autoplay = this.dataset.autoplay === 'true'; // <announcement-bar-slider data-autoplay="true" data-speed="4000">
    this.speed = parseInt(this.dataset.speed) || 4000;
    this.timer = null;

    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.showPrev();
        this.resetAutoplay();
      });
      this.nextBtn.addEventListener('click', () => {
        this.showNext();
        this.resetAutoplay();
      });
    }

    this.updateSlides();

    if (this.autoplay) {
      this.startAutoplay();

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  connectedCallback() {
    this.setAnnouncementBarHeight();
  }
  showPrev() {
    this.currentIndex = (this.currentIndex - 1 + this.total) % this.total;
    this.updateSlides();
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.total;
    this.updateSlides();
  }

  updateSlides() {
    this.slides.forEach((slide, index) => {
      if (index === this.currentIndex) {
        slide.removeAttribute('aria-hidden');
        slide.setAttribute('tabindex', '0');
        slide.style.display = 'block';
      } else {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('tabindex', '-1');
        slide.style.display = 'none';
      }
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.showNext();
    }, this.speed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  resetAutoplay() {
    if (this.autoplay) {
      this.startAutoplay();
    }
  }
  setAnnouncementBarHeight() {
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight}px`);
  }
}
if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
